import React, { memo } from 'react'
import { useNavigate } from 'react-router-dom'

function BackButton(props) {
    const { handlePrevNavigation } = props;

    const navigate = useNavigate()

    return (
        <button
            onClick={() => {
                if (Boolean(handlePrevNavigation) && typeof handlePrevNavigation === "function") {
                    return handlePrevNavigation()
                }

                navigate(-1)
                window.scrollTo(0, 0);
            }}
            className="absolute left-2 top-2 bg-transparent rounded-lg p-3 border-none outline-none focus:outline-none"
        >
            <svg width="25" height="19" viewBox="0 0 25 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.98438 7.91667L11.5781 2.2325L9.375 0L0 9.5L9.375 19L11.5781 16.7675L5.98438 11.0833H25V7.91667H5.98438Z" fill="#B7E5E4" />
            </svg>

        </button>
    )
}

export default memo(BackButton)